import script from "./ColorCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorCard.vue?vue&type=script&setup=true&lang=js"

import "./ColorCard.vue?vue&type=style&index=0&id=b7e35478&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e35478"]])

export default __exports__